import React from "react";
import { Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap";

export default function CustomModalSARChangeHoursAndRecertification(props) {
  const { toggle, open, onSave } = props;

  const onSubmit = (updateHours = false) => {
    onSave(updateHours);
    toggle();
  };

  return (
    <Modal size="sm" toggle={toggle} isOpen={open} className="persona">
      <ModalHeader toggle={toggle} charCode="x"></ModalHeader>
      <ModalBody>
        <Card>
          <CardBody>
            <div>
              <h2>
                ¿Quieres modificar las horas y período de recertificación
                guardados por los valores actuales?
              </h2>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ flex: 1, marginRight: 10 }}
                  onClick={() => onSubmit(true)}
                >
                  Sí, modificar
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ flex: 1, marginLeft: 10 }}
                  onClick={() => onSubmit(false)}
                >
                  No, no modificar
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}

CustomModalSARChangeHoursAndRecertification.defaultProps = {
  toggle: () => {},
};
